import { useEffect, useMemo, useRef, useState } from 'react';

const BROWSER = 'BROWSER';
const NATIVE = 'NATIVE';
const SERVER = 'SERVER';

const canUseDOM = !!(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
);

const canUseNative =
  typeof navigator !== 'undefined' && navigator.product === 'ReactNative';
const location = canUseNative ? NATIVE : canUseDOM ? BROWSER : SERVER;

const useRenderingEnv = () => {
  const mounted = useRef(false);
  const [renderingEnv, setRenderingEnv] = useState(location);

  useEffect(() => {
    if (mounted.current) {
      return;
    }
    mounted.current = true;
    setRenderingEnv(location);
  });

  return useMemo(
    () => ({
      canUseEventListeners:
        renderingEnv === BROWSER && !!window.addEventListener,
      canUseViewport: renderingEnv === BROWSER && !!window.screen,
      canUseWorkers: typeof Worker !== 'undefined',
      isBrowser: renderingEnv === BROWSER,
      isNative: renderingEnv === NATIVE,
      isServer: renderingEnv === SERVER,
    }),
    [renderingEnv]
  );
};

export default useRenderingEnv;
